import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';

/**
 * Cambio de contraseña. Si `onCancel` no viene, es obligatorio (primer ingreso
 * o contraseña restablecida por el admin) y solo se puede cerrar sesión.
 */
export default function ChangePasswordPage({ onCancel, onDone }) {
  const { user, changePassword, logout } = useAuth();
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const forced = !onCancel;

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    if (next !== confirm) {
      setError('La confirmación no coincide');
      return;
    }
    setLoading(true);
    try {
      await changePassword(current, next);
      onDone?.();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={s.root}>
      <div style={s.card}>
        <h1 style={s.title}>Cambiar contraseña</h1>
        <p style={s.subtitle}>
          {forced
            ? `Hola ${user?.name || ''}. Antes de continuar, define una contraseña personal.`
            : 'Al cambiarla se cerrarán tus sesiones en otros equipos.'}
        </p>

        <form onSubmit={handleSubmit} style={s.form}>
          <Field label={forced ? 'Contraseña actual o temporal' : 'Contraseña actual'}
            value={current} onChange={setCurrent} autoComplete="current-password" />
          <Field label="Nueva contraseña" value={next} onChange={setNext} autoComplete="new-password" />
          <Field label="Confirmar nueva contraseña" value={confirm} onChange={setConfirm} autoComplete="new-password" />

          <div style={s.hint}>Mínimo 10 caracteres, con letras y números.</div>

          {error && <div style={s.errorBox}>⚠️ {error}</div>}

          <button type="submit" style={{ ...s.btn, opacity: loading ? 0.7 : 1 }} disabled={loading}>
            {loading ? 'Guardando...' : 'Guardar contraseña'}
          </button>
          <button type="button" style={s.secondaryBtn} onClick={forced ? logout : onCancel}>
            {forced ? 'Cerrar sesión' : 'Cancelar'}
          </button>
        </form>
      </div>
    </div>
  );
}

function Field({ label, value, onChange, autoComplete }) {
  return (
    <div style={s.field}>
      <label style={s.label}>{label}</label>
      <input
        style={s.input}
        type="password"
        value={value}
        onChange={e => onChange(e.target.value)}
        autoComplete={autoComplete}
        required
      />
    </div>
  );
}

const s = {
  root: {
    minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
    background: 'var(--bg)', padding: 20, fontFamily: "'Plus Jakarta Sans', sans-serif",
  },
  card: {
    background: 'var(--surface)', border: '1px solid var(--border)',
    borderRadius: 24, padding: '36px 32px', width: '100%', maxWidth: 420,
    boxShadow: 'var(--shadow-md)',
  },
  title: { fontSize: 24, fontWeight: 800, color: 'var(--text)', marginBottom: 8 },
  subtitle: { fontSize: 14, color: 'var(--text-3)', marginBottom: 24, lineHeight: 1.5 },
  form: { display: 'flex', flexDirection: 'column', gap: 16 },
  field: { display: 'flex', flexDirection: 'column', gap: 8 },
  label: { fontSize: 12, fontWeight: 600, color: 'var(--text-2)', textTransform: 'uppercase', letterSpacing: 1 },
  input: {
    background: 'var(--surface-2)', border: '1px solid var(--border)',
    borderRadius: 12, padding: '12px 16px', color: 'var(--text)', fontSize: 14, outline: 'none',
  },
  hint: { fontSize: 12, color: 'var(--text-3)' },
  errorBox: {
    background: 'var(--danger-soft)', border: '1px solid var(--danger-border)',
    borderRadius: 10, padding: '10px 14px', color: 'var(--danger)', fontSize: 13,
  },
  btn: {
    background: 'var(--accent-gradient)', border: 'none', borderRadius: 12,
    padding: '13px 20px', color: 'var(--on-accent)', fontWeight: 700, fontSize: 15, cursor: 'pointer',
  },
  secondaryBtn: {
    background: 'transparent', border: '1px solid var(--border-strong)', borderRadius: 12,
    padding: '11px 20px', color: 'var(--text-2)', fontSize: 14, cursor: 'pointer',
  },
};
